const NotFoundPage: React.FC = () => <h2>404</h2>;

export default NotFoundPage;
